import useAuth from '../hooks/useAuth'
import { Navigate, Outlet } from 'react-router-dom'

const AdminPrivateRouter = () => {
  const currentUser = useAuth()
  return currentUser === 1 ? <Outlet /> : <Navigate to={'/admin/login'} />
  // return <Outlet />
}

export default AdminPrivateRouter